module.exports = __webpack_public_path__ + "img/podiatre-background3.e4827538.jpg";